import ProtectedPageSidebar from 'engage/components/Sidebar/ProtectedPageSidebar';
import React, { useEffect, useMemo, useState } from 'react';
import ContentCalendar from './components/ContentCalendar/ContentCalendar';
import VideoService from 'engage/service/VideoService';
import { ToastNotification } from 'engage/components/Toast/Toast';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import { setHours } from "date-fns";


const SchedulePage = ({ }) => {
    const [events, setEvents] = useState([]);
    const { t } = useTranslation();

    const preparedEvents = useMemo(() => {
        return events.map(event => {
            const start = new Date(event.start);
            const end = event?.end ? new Date(event.end) : setHours(start, start.getHours() + 1)
            return ({ ...event, start, end, hasDeadline: event.end !== null })
        })
    }, [events])

    const loadUserEvents = async () => {
        const events = await VideoService.getMySchedule();
        setEvents(events);
    }

    const onSaveEvent = async (videoId, data, isNew = false) => {
        try {

            const payload = {
                ...(data?.start ? { start: new Date(data.start).toISOString() } : {}),
                ...(data.hasOwnProperty('end') ? { end: data.end ? new Date(data.end).toISOString() : null } : {}),
                notes: data?.notes,
                ...(data?.newNotifications ? { notifications: data.newNotifications } : {}),
            }
            if (isNew) {
                await VideoService.createStorySchedule(videoId, payload);
            } else {
                const updatedSchedule = await VideoService.updateStorySchedule(videoId, payload);
                if (data?.editNotifications?.length) {
                    const notifications = updatedSchedule.notifications.map(notification => {
                        const updated = data?.editNotifications.find(item => item.id == notification.id);
                        if (updated) {
                            return { ...notification, ...updated };
                        }
                        return notification;
                    });
                    await VideoService.updateScheduleNotifications(videoId, notifications);
                }
            }
            await loadUserEvents();
        } catch (e) {
            console.error('Error while scheduling a story', e);
            if (e?.response?.status === 409) {
                ToastNotification({ message: t('storyboard.editor.schedule.conflict'), closeButton: true });
                return;
            }
            Sentry.captureException(e);
            ToastNotification({ message: t('storyboard.editor.schedule.error'), closeButton: true });
        }
    }

    const onRemoveEvent = async (videoId) => {
        try {
            await VideoService.removeSchedule(videoId);
            await loadUserEvents();
        } catch (e) {
            console.error('Error while scheduling a story', e);
            Sentry.captureException(e);
            ToastNotification({ message: t('storyboard.editor.schedule.error'), closeButton: true });
        }
    }

    useEffect(() => {
        loadUserEvents();
    }, [])

    return (
        <>
            <ProtectedPageSidebar />
            <ContentCalendar events={preparedEvents} onSaveEvent={onSaveEvent} onRemoveEvent={onRemoveEvent} />
        </>
    );
}

export default SchedulePage;